import React from 'react';
import * as LucideIcons from 'lucide-react';
import { BrandedIcons } from './icons/BrandedIcons';

export const ICON_MAP = {
    // Core Features (Branded)
    ai: 'ai',
    lessons: 'lessons',
    quizzes: 'quizzes',
    finalQuiz: 'finalQuiz',
    parent: 'parent',
    progress: 'Trophy',

    // UI Elements (Lucide)
    streak: 'Flame',
    achievement: 'Award',
    next: 'ChevronRight',
    back: 'ChevronLeft',
    lock: 'Lock',
    unlock: 'LockOpen',
    play: 'Play',
    clock: 'Clock',
    target: 'Target',
    check: 'CheckCircle2',
    star: 'Star',
    rocket: 'Rocket',
    sparkles: 'Sparkles',
    mail: 'Mail',
    user: 'User',
    logout: 'LogOut',
    bell: 'Bell',
    eye: 'Eye',
    eye_off: 'EyeOff',
    x: 'X'
};

const Icon = ({ name, size = 24, color = 'currentColor', className = '', ...props }) => {
    const iconKey = ICON_MAP[name] || name;

    // 1. Check for Branded Icon
    const BrandedIcon = BrandedIcons[iconKey];
    if (BrandedIcon) {
        return (
            <BrandedIcon
                size={size}
                color={color}
                className={`cw-icon-branded ${className}`}
                {...props}
            />
        );
    }

    // 2. Fallback to Lucide
    const LucideIcon = LucideIcons[iconKey];
    if (LucideIcon) {
        return (
            <LucideIcon
                size={size}
                color={color}
                className={`cw-icon-lucide ${className}`}
                {...props}
            />
        );
    }

    console.warn(`Icon "${name}" not found in Branded or Lucide libraries.`);
    return null;
};

export default Icon;
